import axios from "~/axios";
import getConfig from '~/config';
import Cookies from 'js-cookie';

let promise = null;


const refreshToken = async (promiseCall) => {
    if (promise) await promise;
    if (!Cookies.get("accessToken") && Cookies.get("refreshToken")) {
        promise = axios.get(`${getConfig().baseUrl}/refreshToken`, {
            headers: { bearer: Cookies.get("refreshToken") },
        });

        const authResult = (await promise);
        promise = null;
    }

    return promiseCall();
};

export default refreshToken;